import React, { Fragment } from 'react';
import DropdownNew from 'src/ui/library/DropdownNew';
import InfoTooltip from 'src/ui/library/ToolTip/InfoTooltip';
import findIndex from 'lodash.findindex';
import DOMPurify from 'dompurify';
import intl from 'react-intl-universal';
import iconTransform from 'src/helpers/iconTransform.js';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import ErrorIcon from '@mui/icons-material/Error';

class DropdownControl extends React.Component {
  static defaultProps = {
    listOptions: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.convertValue(this.props.value) || '',
      isDisabled: this.props.readOnly,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.convertValue(this.props.value) });
    }
    if (prevProps.readOnly !== this.props.readOnly) {
      this.setState({ isDisabled: this.props.readOnly ? true : this.state.readOnly });
    }
  }

  /*
   *  5/7/2019 - BE has stated it can not accept empty strings or nulls for dropdown so we need to send '(Select)' as is
   *
   */
  convertValue = value => {
    return value !== null && value !== undefined && value.indexOf('(Select)') >= 0 ? '' : value;
  };

  getSelectLookupBindVal = () => {
    const lookUpIndex = findIndex(this.props.listOptions, item => item.displayText === '(Select)');
    return lookUpIndex !== -1 ? this.props.listOptions[lookUpIndex].lookUpBindValue : '';
  };

  handleOnChange = event => {
    let value = event && event.target ? event.target.value : event;

    if (value === '' || value === null) {
      value = this.getSelectLookupBindVal();
    }
    //if lockAfterValueChange prop is true , then disable field on change
    const isDisabled = this.props.lockAfterValueChange ? true : this.state.isDisabled;
    this.setState({ value, isDisabled });
    this.props.onChange({
      type: 'change',
      target: {
        ...(event && event.target ? event.target : {}),
        id: this.props.id,
        name: this.props.id,
        value,
      },
    });
  };

  renderDropdown() {
    let { id, label, required, listOptions, hasError, align } = this.props;

    if (listOptions === null) listOptions = [{ lookUpBindValue: 'missingdata', displayText: 'Missing Data' }];
    const finalOptions = listOptions.filter(item => item.displayText !== '(Select)');
    if (this.props.origControlTypeName === 'CountryList' && this.props.profileCountryCode) {
      let profileCountryIndex = finalOptions.findIndex(country => country.lookupCode === this.props.profileCountryCode);
      if (profileCountryIndex) {
        finalOptions.unshift(finalOptions.splice(profileCountryIndex, 1)[0]);
      }
    }

    return (
      <Fragment>
        <DropdownNew
          required={required}
          options={finalOptions.map(item => ({ value: item.lookUpBindValue, label: item.displayText }))}
          id={id}
          useEllipsisLabel={true}
          name={id}
          label={label}
          value={this.state.value}
          onChange={this.handleOnChange}
          isDisabled={this.state.isDisabled}
          hasError={hasError}
          align={align}
        />
      </Fragment>
    );
  }

  render() {
    const { helpText, hasError, align, icon, description, showText, hasParentTable, ...otherProps } = this.props;
    const errorText = intl.get('contentparser.controlErrorMessage');

    let finalText = '';
    finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName], otherProps.increaseFontSize);
    finalText = showText === true ? finalText : '';
    const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

    return (
      <Fragment>
        <div className={`control-text flex-column ${alignClass}`}>
          {finalText && !hasParentTable ? (
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}></div>}
              <div className={'control-icons-inline-controls label-field'}>
                <span component="legend" className="control-label">
                  {finalText}
                </span>
              </div>
            </div>
          ) : null}
          {
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
              <div className={`control-icons-inline-controls ${helpText ? 'with-tooltip' : ''} ${icon ? 'with-icon' : ''}`}>
                {helpText ? (
                  <InfoTooltip toolTipText={helpText} labelText={this.renderDropdown()} className="dropdown-tooltip" />
                ) : (
                  this.renderDropdown()
                )}
                {hasError && <p className="textfield-error-text"> <ErrorIcon sx={{ verticalAlign:'bottom', fontSize: 14 }}/> <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorText) }} /></p>}
              </div>
            </div>
          }
        </div>
      </Fragment>
    );
  }
}

export default DropdownControl;
